import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ActivityDetailsComponent } from './activity-details.component';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [
    ActivityDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    PipesModule
  ],
  exports: [
    ActivityDetailsComponent
  ]
})
export class ActivityDetailsModule { }
